import api from '../../../lib/api';
import { ResourceFetch } from '../../../meta/types/api';
import { CONFIG } from '../../../meta/types/config';
import { Domain } from '../../../meta/types/user';

const { GET } = api;

const DOMAIN_RESOURCE_BASE_PATH = `${CONFIG.identityServiceBasePath}/oauth/domains`;

export interface DomainResource {
  get: ResourceFetch<Domain, { domainId: number }>;
}

const DomainResource: DomainResource = {
  get: GET(`${DOMAIN_RESOURCE_BASE_PATH}/:domainId`),
};

export default DomainResource;
